import { PreviewFrame } from "./PreviewFrame";

interface Lead {
  name: string;
  email: string;
  stage: string;
  stageColor: string;
  assignee: string;
  initials: string;
  avatarColor: string;
}

const LEADS: Lead[] = [
  {
    name: "Nova Shimmer",
    email: "shimmer.jade@wondermail.com",
    stage: "New",
    stageColor: "#52c535",
    assignee: "Mia Thompson",
    initials: "MT",
    avatarColor: "#00a7de"
  },
  {
    name: "Stella Glow",
    email: "sapphire@creativemail.com",
    stage: "Contacted",
    stageColor: "#f2c94c",
    assignee: "Ethan Carter",
    initials: "EC",
    avatarColor: "#e6007e"
  },
  {
    name: "Celeste Spark",
    email: "spark.celeste@artisticmail.com",
    stage: "Tour requested",
    stageColor: "#f2994a",
    assignee: "Sophie Reynolds",
    initials: "SR",
    avatarColor: "#52c535"
  }
];

const Avatar = ({ initials, color }: { initials: string; color: string }) => (
  <span
    className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[7px] font-black text-white"
    style={{ backgroundColor: color }}
    aria-hidden="true"
  >
    {initials}
  </span>
);

export const LeadsPreview = () => (
  <PreviewFrame>
    {/* Lead column — 257px */}
    <div className="flex w-[257px] flex-col">
      <div className="flex h-11 items-center px-4 py-3">
        <span className="text-[13px] font-medium leading-4 text-content-300">
          Lead
        </span>
      </div>
      {LEADS.map((lead) => (
        <div
          key={lead.email}
          className="flex h-16 flex-col justify-center border-t border-alpha-40 px-4 py-3"
        >
          <span className="text-[14px] font-medium leading-5 text-content-1000">
            {lead.name}
          </span>
          <span className="text-[13px] font-normal leading-4 text-content-400">
            {lead.email}
          </span>
        </div>
      ))}
    </div>

    {/* Stage column — flex-1 */}
    <div className="flex flex-1 flex-col">
      <div className="flex h-11 items-center py-3">
        <span className="text-[13px] font-medium leading-4 text-content-300">
          Stage
        </span>
      </div>
      {LEADS.map((lead) => (
        <div
          key={lead.email}
          className="flex h-16 items-center border-t border-alpha-40"
        >
          <div className="flex items-center gap-2 rounded-full px-2 py-1">
            <span
              className="h-3 w-3 shrink-0 rounded-full"
              style={{ backgroundColor: lead.stageColor }}
              aria-hidden="true"
            />
            <span className="whitespace-nowrap text-[13px] font-medium leading-4 text-content-1000">
              {lead.stage}
            </span>
          </div>
        </div>
      ))}
    </div>

    {/* Assigned to column — 172px */}
    <div className="flex w-[172px] flex-col">
      <div className="flex h-11 items-center py-3">
        <span className="text-[13px] font-medium leading-4 text-content-300">
          Assigned to
        </span>
      </div>
      {LEADS.map((lead) => (
        <div
          key={lead.email}
          className="flex h-16 items-center border-t border-alpha-40"
        >
          <div className="flex items-center gap-2 rounded-full bg-background-900 px-2 py-1">
            <Avatar initials={lead.initials} color={lead.avatarColor} />
            <span className="whitespace-nowrap text-[13px] font-medium leading-4 text-content-1000">
              {lead.assignee}
            </span>
          </div>
        </div>
      ))}
    </div>
  </PreviewFrame>
);
